import { render, staticRenderFns } from "./compostPanel.vue?vue&type=template&id=8a8a7b40&scoped=true&"
import script from "./compostPanel.vue?vue&type=script&lang=js&"
export * from "./compostPanel.vue?vue&type=script&lang=js&"
import style0 from "./compostPanel.vue?vue&type=style&index=0&id=8a8a7b40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a8a7b40",
  null
  
)

export default component.exports